<script>
import Store from '@phoenix/components/Store';
import StoreSearchResultsTabMap from '@phoenix/mixins/components/store/StoreSearchResultsTabMap';
import { default as StoreSearchFormMixin } from '@phoenix/mixins/components/store/StoreSearchForm';
import StoreSearchForm from '@maison/components/store/StoreSearchForm';

import { PhxStoreLocator } from '@phx-styleguides/rdu';
import { mapState } from 'vuex';

export default {
  components: {
    PhxStoreLocator,
    StoreSearchForm,
  },

  mixins: [StoreSearchResultsTabMap, StoreSearchFormMixin],

  data() {
    return {
      selectedFilters: [],
    };
  },

  computed: {
    ...mapState('storeSearch', ['placeSuggestions']),

    getStores() {
      let stores = this.stores.length ? this.stores : this.allStores;

      if (this.selectedFilters.length) {
        stores = stores.filter((s) => this.selectedFilters.includes(s.type));
      }

      return stores.map((store) => {
        const status = store.isReseller
          ? null
          : new Store(store.openingHours, store.specialDays, store.timezone, store.isOnline, store.id).getStatusLabel();

        store = this.addPictureToStoreIfPossible(store);

        return { ...store, status };
      });
    },

    filters() {
      return [
        {
          value: 'boutique',
          label: this.$t('storeSearch.boutiquesType'),
          icon: 'monogram-16',
        },
        {
          value: 'reseller',
          label: this.$t('storeSearch.resellersType'),
        },
      ];
    },
  },

  methods: {
    onLocationSelect(event, { origin }) {
      window.tracking.pushEvent(
        window.tracking.getStoreLocatorLocationSelectedTracking(event.name, event.type, origin),
      );

      window.location.href = event.permalink;
    },

    addPictureToStoreIfPossible(store) {
      if (!store.rokkaImg) {
        return store;
      }

      const picture = {
        sources: store.rokkaImg.sources.map((sourceItem) => ({
          width: sourceItem.width,
          height: sourceItem.height,
          srcset: sourceItem.srcset.split(', ').map((setItem) => ({
            path: setItem.split(' ')[0],
          })),
        })),
        image: {
          src: store.rokkaImg.image.src,
          width: store.rokkaImg.image.width,
          height: store.rokkaImg.image.height,
        },
      };

      return { ...store, picture };
    },
  },
};
</script>

<template>
  <phx-store-locator
    ref="storeLocator"
    v-model:selected-filters="selectedFilters"
    :api-key="apiKey"
    :map-id="mapId"
    :engine="engine"
    :center="center"
    :zoom="zoom"
    :geolocation="position"
    :fit-bounds="fitBounds"
    :locations="getStores"
    :region="region"
    :panel-title="$t('Styleguide.store-locator.title')"
    :panel-subtitle="$t('Styleguide.store-locator.subtitle')"
    :close-button-label="$t('Button.close')"
    :open-panel-button-label="$t('StoreSearch.storesList')"
    :get-direction-link-label="$t('Store.getDirections')"
    :panel-close-button-label="$t('storeSearch.hidePanel')"
    :card-close-button-label="$t('storeSearch.closeDetails')"
    :filters-title="$t('storeSearch.ourStores')"
    :filters-subtitle="$t('storeSearch.filterTheResults')"
    :geolocation-button-label="$t('storeSearch.searchCloseToMe')"
    :see-details-button-label="$t('storeSearch.seeDetails')"
    :boutique-badge-label="$t('storeSearch.boutiques')"
    :filters="filters"
    @map:initialized="onMapInitialized"
    @map:bounds:changed="onMapBoundsChanged"
    @location:select="onLocationSelect"
    @geolocation:enable="useMyPosition"
  >
    <template #autocomplete>
      <div>
        <store-search-form :display-position-button="false" :placeholder="$t('Store.storeSelector.enterCountryCity')" />
      </div>
    </template>
  </phx-store-locator>
</template>
